import GaugeChart from "react-gauge-chart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../../AppProvider";
import { faLoader } from "../../../utilities/fontawesomeIcons";
import moment from "moment";
import { useInView } from "react-intersection-observer";
import { Carrier } from "../../../Models/Carrier";
import { useShipmentsPerformancesFirstAttemptDeliveredContext } from "../providers/ShipmentsPerformancesFirstAttemptDelivered";
import { useMemo } from "react";

const DeliveredOnTheFirstTry = () => {
  const { dictionary } = useAppContext();
  const { data, loader, filters } =
    useShipmentsPerformancesFirstAttemptDeliveredContext();
  const { ref, inView } = useInView({ triggerOnce: true });

  const gaugeContent = useMemo(() => {
    if (!inView || !data?.length) return null;
    return (
      <div className="row mt-2 justify-content-center">
        {inView &&
          data.map((t, i) => {
            const carrier = t.type as Carrier;
            return (
              <div className="col-4 mb-2" key={i}>
                <GaugeChart
                  id="DeliveredOnTheFirstTryGauge_"
                  nrOfLevels={10}
                  textColor="transparent"
                  colors={["#EA4228", "#F5CD19", "#5BE12C"]}
                  percent={t.partial / t.total}
                  arcPadding={0.02}
                  animate={false}
                />
                <label className="label-4">
                  {((t.partial * 100) / t.total).toFixed(2)}%
                </label>
                <label className="label-2">
                  {t.partial} su {t.total}
                </label>
                <img
                  style={{ maxHeight: "2rem", maxWidth: "4rem" }}
                  src={carrier.logoUrl}
                  title={carrier.name}
                />
              </div>
            );
          })}
      </div>
    );
  }, [inView, data]);

  return (
    <div ref={ref} className="box-container text-center h-100">
      <div className="row align-items-center mb-1">
        <div className="col">
          <label className="label-4">{dictionary.kpi.fulfillment_rate}</label>
          <label className="label-2">
            {moment(filters.start).isSame(moment(filters.end), "day")
              ? moment(filters.start).format("DD/MM/YYYY")
              : moment(filters.start).format("DD/MM/YYYY") +
                " - " +
                moment(filters.end).format("DD/MM/YYYY")}
          </label>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label className="label-5">
            {dictionary.kpi.fulfillment_rate_desc}
          </label>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col">
          {loader ? (
            <FontAwesomeIcon icon={faLoader} spin size="4x" />
          ) : data?.length ? (
            gaugeContent
          ) : (
            <label className="label-3">
              {dictionary.messages.no_results_found}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveredOnTheFirstTry;
